<template>
    <div>
        <div class="Chatroom-screen-message-approval-block">
            <div class="active-user-info">
                <div class="return-chat" @click="$emit('handleBackClick')">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                    </svg>
                </div>
                <div class="active-user-meta">
                    <ul>
                        <li class="active-user-avatar">
                            <span class="active-status" v-if="recepientUser.onlineStatus"></span>
                            <img :src="profileImage" alt="Active User Info">
                        </li>
                        <li class="active-user-avatar-info">
                            <p class="active-user-name">{{ recepientUser.name }}</p>
                            <p class="active-status-text" v-if="recepientUser.onlineStatus">{{ $t('screener.chatroom.user.active.now.label') }}</p>
                        </li>
                    </ul>
                </div>
                <div class="active-user-icons">
                    <ul>
                        <li>
                            <a href="javascript:void(0)" @click="$emit('closeDrawer')">
                                <button class="close-button" >
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                        class="size-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="chatroom-message-area">
            <ChatArea 
                v-model="typedMessage"
                :isApproved="isApproved"
                :sender="senderUser"
                :receiver="recepientUser"
                :chatMessages="chatMessages"
                @reactionToMessage="reactionToMessage"
                @manageProfileApproval="manageProfileApproval"
                @sendMessage="sendMessage"
            /> 
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ChatRoomService from "@/services/ChatRoomService";

import ChatArea from "../Presentational/ChatArea.vue";

import { convertObjectToArray } from '../helper/HelperFunctions'

import defaultProfileImage from '@/assets/placeholder.jpg';

export default {
    name: 'MemberOneToOneChat',
    data(){
        return {
            showHanldeRequestLoader:false,
            showChat:true,
            typedMessage:null,
            chatUniqueId:null,
            privateChatMessages:[]
        }
    },
    props:{
        chatRoomID: {
            type:String,
            require:true
        },
        senderUser :{
            type:Object,
            default:null
        },
        recepientUser:{
            type:Object,
            default:null
        }
    },
    components :{
        ChatArea,
    },
    computed:{
        chatMessages() {
            let messages = []
            if (this.privateChatMessages) {
                messages = Object.entries(this.privateChatMessages).map(([messageDocID, messageData]) => {
                    
                    if (messageData.reactions) {
                        messageData.reactions = convertObjectToArray(messageData.reactions)
                    }else{
                        messageData.reactions = []
                    }

                    return {
                        id: messageDocID,
                        ...messageData
                    }
                });
            }

            return messages
            
        },
        isApproved: {
            get() {
                if (this.chatMessages.length == 0) {
                    return true
                }else{
                    if (this.chatMessages[0].senderId == this.recepientUser.id) {
                        return this.chatMessages[0].approved
                    }else{
                        return true
                    }
                }
            },
            set(value) {
                return value
            },
            
        },
        profileImage() {
            return this.recepientUser.profile_image || defaultProfileImage;
        },
    },
    async created(){
        await this.activateChatMessageListener()
    },
    async beforeDestroy() {
        await this.deactivateChatMessageListener();
    },
    methods: {
        async activateChatMessageListener() {
            // Set Chat Room id
            this.chatUniqueId =  await ChatRoomService.__createPrivateChat(this.chatRoomID, this.senderUser.id, this.recepientUser.id)
            await this.listenToChatMessages()
            await this.markChatAsRead()
        },
        async deactivateChatMessageListener() {
            await ChatRoomService.stopListeningToPrivateMessages(this.chatRoomID, this.chatUniqueId)
        },
        async listenToChatMessages() {
            await ChatRoomService.listenToPrivateChatMessages(this.chatRoomID,this.chatUniqueId, (snapshot) => {
                if (snapshot) {
                    this.privateChatMessages = snapshot
                }
            });
        },
        async markChatAsRead() {
            await ChatRoomService.setChatMessagesAsRead(this.chatRoomID, this.chatUniqueId)
        },
        async manageProfileApproval(type) {
            console.log(type);
            let response = await ChatRoomService.__approveRejectFirstMessage(
                this.chatRoomID,
                this.senderUser.id, 
                this.recepientUser.id,
                type
            )
            
            if (type == 'approve') {
                this.showHanldeRequestLoader = false
            }else if(type == 'reject'){
                this.$emit('handleBackClick')
            }
            
        },
        async sendMessage(){
            if(this.typedMessage){
                let message = this.typedMessage
                this.typedMessage = null
                
                // If Message is First message in chat then set message approve status to false
                if (Object.keys(this.privateChatMessages).length == 0) {
                    await ChatRoomService.__addPrivateMessage(this.chatRoomID, this.chatUniqueId, this.senderUser.id, this.recepientUser.id, message,'text',null, 'not_approved')
                }else{
                    await ChatRoomService.__addPrivateMessage(this.chatRoomID, this.chatUniqueId, this.senderUser.id, this.recepientUser.id, message)
                }
                
            }
            
        },
        async reactionToMessage({message_id, message_reaction, current_reaction}) {
            if (message_reaction === current_reaction) {
                await ChatRoomService.__removeReactionFromMessage(this.chatRoomID, this.chatUniqueId, message_id)
            }else{
                await ChatRoomService.__addReactionToMessage(this.chatRoomID, this.chatUniqueId, message_id, message_reaction)
            }
        }
    }        
}
</script>
